import React from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ArcRoutes } from '../../constants/routes';
import { EmploymentLanding } from './employment-landing/employment-landing';
import { EmploymentState } from './employment-model';
import { useEmploymentInfo } from './useEmployment';
import { Positions } from './positions/positions';
import { AddUnpaidLeave } from './add-unpaid-leave/add-unpaid-leave';
import { TcsmStates } from '../../../../root/tcsm-model';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { useGetCurrentEmployeeFromEmployeeList } from '../new-hire-enrollment/hooks/useGetCurrentEmployeeFromEmployeeList';

export function Employment() {
    const routeMatch = useRouteMatch();
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	useGetCurrentEmployeeFromEmployeeList();
    const employmentInfoLoaded = useEmploymentInfo();

	if (!employmentState?.currentEmployee) {

		const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
		return (
			<Redirect to=
				{
					{
						pathname: employeeSelect,
						state: {
							actionLink: routeMatch.path,
						},
					}
				}
			/>);

	}

	if (!employmentInfoLoaded) {
		return <LoadingCircle />;
	}


	return (
		<>
            <Switch>
                <Route exact path={routeMatch.path} component={EmploymentLanding} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.Position}`} component={Positions} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.AddUnpaidLeave}`} component={AddUnpaidLeave} />
			</Switch>
		</>
	);
}